import React from "react";
import desk from "./../assets/img/team-section-story.jpg";
import { useTranslation } from "react-i18next";

const StorySection = () => {
  const { t } = useTranslation();

  return (
    <section className="swiss-section">
      <div className="swiss-grid">
        <div className="col-span-12 lg:col-span-2 mb-6 lg:mb-0">
          <span className="swiss-num">02 / {t("Origins")}</span>
        </div>

        <div className="col-span-12 lg:col-span-5">
          <div className="w-full aspect-[4/5] overflow-hidden">
            <img
              src={desk}
              alt="Workspace"
              className="w-full h-full object-cover object-center grayscale"
            />
          </div>
        </div>

        <div className="col-span-12 lg:col-span-5 flex flex-col gap-5">
          <h2 className="text-h2 font-bold tracking-tight text-ink max-w-[16ch]">
            {t("Our Origins and Story")}
          </h2>
          <p className="text-body-lg text-ink-70 max-w-measure">
            {t(
              "Diversity is the heartbeat of our team — a collective of developers, designers, strategists, and visionary thinkers."
            )}
          </p>
          <p className="text-body text-ink-70 max-w-measure">
            <strong className="text-ink">Bogowi</strong>{" "}
            {t(
              "blends technology, design, and flawless execution. Our mission: a path to measurable conservation impact amidst evolving demands and technologies."
            )}
          </p>
          <p className="text-body text-ink-70 max-w-measure">
            {t(
              "Over a decade of steering successful projects, we've redefined digital innovation. Our solutions transcend boundaries — simplicity, usability, impact."
            )}
          </p>
          <p className="text-body text-ink-70 max-w-measure">
            {t(
              "With your audience at the forefront, we pose a pivotal question throughout each project:"
            )}{" "}
            <strong className="text-ink">
              {t("'Does it fuel your business growth?'")}
            </strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
